export const createTaxDeductionFormRepository = (appFetch) => {
    return {
        preload() {
            return appFetch.get('/cabinet/api/simple-property-deduction/preload');
        },
        checkpoint(payload) {
            return appFetch.post('/cabinet/api/simple-property-deduction/checkpoint', payload);
        },
        statistic(step) {
            return appFetch.post('/cabinet/api/simple-property-deduction/stat', {step});
        },
        send(payload) {
            return appFetch.post('/cabinet/api/simple-property-deduction', payload);
        },
        uploadFile(payload) {
            return appFetch.post('/cabinet/api/simple-property-deduction/upload', payload);
        },
        previewFile(filename) {
            return appFetch.get(`/cabinet/api/simple-property-deduction/preview/${filename}`);
        },
        deleteFile(filename) {
            return appFetch.delete(`/cabinet/api/simple-property-deduction/delete/${filename}`);
        },
    };
};
